import CompanyChallengeManagement from '@/components/challenge/CompanyChallengeManagement/CompanyChallengeManagement';
import useCompany from '@/hooks/useCompany';
import { CircularProgress } from '@mui/material';
import React from 'react';

const CompanyChallenge: React.FC = () => {
  const { company } = useCompany();

  if (!company) {
    return <CircularProgress />;
  }

  return (
    <CompanyChallengeManagement
      companyId={company.id}
      companyName={company.name}
    />
  );
};

export default CompanyChallenge;
